// set a question checkbox as selected
export function updateNumericEntry(state, payload) {
  return {
    ...state,
    currentSection: updateNumericEntryCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateNumericEntryCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateNumericEntryComponents(currentSection.components, payload),
  };
}

function updateNumericEntryComponents(components, payload) {
  const updateComponent = (component) => {
    if (component.id === payload.componentID) {
      component = updateNumericEntryNEQComponent(component, payload);
    }
    return component;
  };
  return components.map(updateComponent);
}

function updateNumericEntryNEQComponent(component, payload) {
  component.numericEntry = payload.numericEntry;
  return component;
}
